/**
 *
 * Volume
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import VolumeWrapper from './styles/VolumeWrapper';
import VolumeBar from './styles/VolumeBar';

function formatNextVolume(event, element) {
  const { clientX, touches } = event;

  if (!element) return;

  const progressRect = element.getBoundingClientRect();
  const progressAmt = touches && touches[0] && touches[0].clientX ? touches[0].clientX  - progressRect.left: clientX - progressRect.left;

  // Return no more than 1 and no less than 0
  const progressPosition = Math.min(1, Math.max(0, progressAmt / progressRect.width));
  if (typeof progressPosition === 'number') return progressPosition;
}

class Volume extends React.PureComponent {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleMouseMoveVolume = this.handleMouseMoveVolume.bind(this);
    this.handleMouseUpVolume = this.handleMouseUpVolume.bind(this);
    this.handleVolumeClick = this.handleVolumeClick.bind(this);
    this.unbindMouseListeners = this.unbindMouseListeners.bind(this);
  }

  handleVolumeClick(event) {
    event.persist();

    this.handleChange(event);
    window.addEventListener('mousemove', this.handleMouseMoveVolume);
    window.addEventListener('touchmove', this.handleMouseMoveVolume);
    window.addEventListener('touchend', this.handleMouseUpVolume);       
    window.addEventListener('mouseup', this.handleMouseUpVolume);
  }

  handleChange(event) {
    const nextVolume = formatNextVolume(event, this.volume);

    if (nextVolume) this.props.onVolumeChange(nextVolume);
  }

  handleMouseMoveVolume(event) {
    const nextVolume = formatNextVolume(event, this.volume);
    if (nextVolume) this.props.onVolumeChange(nextVolume);
  }

  handleMouseUpVolume() {
    this.unbindMouseListeners();
  }

  unbindMouseListeners() {
    window.removeEventListener('mousemove', this.handleMouseMoveVolume);
    window.removeEventListener('touchmove', this.handleMouseMoveVolume);
    window.removeEventListener('touchend', this.handleMouseUpVolume);  
    window.removeEventListener('mouseup', this.handleMouseUpVolume);
  }

  render() {
    const { volume } = this.props;

    return (
      <VolumeWrapper
        onMouseDown={this.handleVolumeClick}
        onTouchStart={this.handleVolumeClick}
        ref={node => (this.volume = node)}
      >
        <VolumeBar volume={volume * 100} />
      </VolumeWrapper>
    );
  }
}

Volume.propTypes = {
  onVolumeChange: PropTypes.func,
  volume: PropTypes.number
};

export default Volume;
